module.exports = __webpack_public_path__ + "static/media/loader-checkout-postventa-derecha.835c5619.gif";